import { Box } from "@mui/joy";
import DarkInput from "../../../common/DarkInput";
import DarkCheckbox from "../../../common/DarkCheckbox";
import CommonModal from "../../../common/CommonModal";
import PermissionsPicker from "./PermissionsPicker";

type RoleCreateModalProps = {
  open: boolean;
  onClose: () => void;
  roleName: string;
  onRoleNameChange: (value: string) => void;
  isEmployee: boolean;
  onIsEmployeeChange: (value: boolean) => void;
  selectedPerms: string[];
  onSelectedPermsChange: (perms: string[]) => void;
  allPermissions: string[];
  permsLoading: boolean;
  onSubmit: () => void;
  canEdit?: boolean;
};

export default function RoleCreateModal(props: RoleCreateModalProps) {
  const {
    open,
    onClose,
    roleName,
    onRoleNameChange,
    isEmployee,
    onIsEmployeeChange,
    selectedPerms,
    onSelectedPermsChange,
    allPermissions,
    permsLoading,
    onSubmit,
    canEdit = true,
  } = props;
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title="Nouveau rôle"
      size="xl"
      fitContentHeight
      onConfirm={onSubmit}
      confirmLabel="Créer"
      submitDisabled={!canEdit || !roleName.trim()}
    >
      <Box sx={{ display: "grid", gap: 1 }}>
        <DarkInput
          placeholder="Nom du rôle"
          value={roleName}
          onChange={(e) => onRoleNameChange(e.target.value)}
          size="sm"
          disabled={!canEdit}
        />
        <DarkCheckbox
          label="Salarié"
          checked={isEmployee}
          onChange={(e) => onIsEmployeeChange(e.target.checked)}
          disabled={!canEdit}
        />
        <PermissionsPicker
          allPermissions={allPermissions}
          selectedPerms={selectedPerms}
          onChange={onSelectedPermsChange}
          loading={permsLoading}
          disabled={!canEdit}
        />
      </Box>
    </CommonModal>
  );
}
